// BEAM UI primitive — Text.
// A thin wrapper over RN Text that selects a named `type` style (variant) and a
// semantic text color role. Screens never set raw fontFamily / fontSize / hex.
import React from 'react';
import { Text as RNText, type TextProps as RNTextProps, type StyleProp, type TextStyle } from 'react-native';
import { theme, type TypeVariant } from '../../theme';

type ColorRole = 'primary' | 'secondary' | 'link' | 'onPrimary' | 'onAccent' | 'danger';

const colorFor: Record<ColorRole, string> = {
  primary: theme.color.text.primary,
  secondary: theme.color.text.secondary,
  link: theme.color.text.link,
  onPrimary: theme.color.text.onPrimary,
  onAccent: theme.color.text.onAccent,
  danger: theme.color.action.danger,
};

export type TextProps = RNTextProps & {
  variant?: TypeVariant;
  color?: ColorRole;
  /** Convenience colour override constrained to a status fg (e.g. badge text). */
  style?: StyleProp<TextStyle>;
};

export function Text({ variant = 'body', color = 'primary', style, ...rest }: TextProps) {
  return <RNText style={[theme.type[variant], { color: colorFor[color] }, style]} {...rest} />;
}
